import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { useState, useRef } from 'react';
import { useEventListener, useWindowSize } from "../../utilities";
import { ANIMATION_DURATION } from "../constants";

var getTouchXAxis = function getTouchXAxis(event) {
  return event.touches[0].clientX;
};

export var useSwipe = function useSwipe(elementRef, onElementDismiss, id) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      elementPosition = _useState2[0],
      setElementPosition = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      elementTransitionStyles = _useState4[0],
      setElementTransitionStyles = _useState4[1];

  var initialTouchXAxisRef = useRef(null);
  var windowSize = useWindowSize();
  var windowWidth = windowSize.width;

  var handleTouchStart = function handleTouchStart(event) {
    event.stopPropagation();
    initialTouchXAxisRef.current = getTouchXAxis(event);
  };

  var handleTouchMove = function handleTouchMove(event) {
    event.stopPropagation();
    var elementCurrentTouchXAxisValue = getTouchXAxis(event);
    var xAxisDistanceFromInitialTouchPoint = elementCurrentTouchXAxisValue - initialTouchXAxisRef.current;
    setElementPosition(xAxisDistanceFromInitialTouchPoint);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    event.stopPropagation();

    if (elementRef.current) {
      var elementDimensions = elementRef.current.getBoundingClientRect();
      var elementWidth = elementDimensions.width;
      var elementDismissAreaPercentage = 0.3;
      var elementDismissArea = Math.round(elementWidth * elementDismissAreaPercentage);
      var isElementDismissableToLeft = elementPosition < -elementDismissArea;
      var isElementDismissableToRight = elementPosition > elementDismissArea;

      if (isElementDismissableToRight) {
        setElementTransitionStyles({
          opacity: 0,
          right: -windowWidth,
          width: elementWidth
        });
        setTimeout(function () {
          onElementDismiss(event, id);
        }, ANIMATION_DURATION);
      } else if (isElementDismissableToLeft) {
        setElementTransitionStyles({
          opacity: 0,
          right: windowWidth,
          width: elementWidth
        });
        setTimeout(function () {
          onElementDismiss(event, id);
        }, ANIMATION_DURATION);
      } else {
        setElementPosition(0);
      }
    }
  };

  var styles = _objectSpread(_objectSpread({}, elementTransitionStyles), {}, {
    transform: "translateX(".concat(elementPosition, "px)")
  });

  useEventListener('touchstart', handleTouchStart, elementRef.current);
  useEventListener('touchmove', handleTouchMove, elementRef.current);
  useEventListener('touchend', handleTouchEnd, elementRef.current);
  return styles;
};